import BaseLayout from '@/components/layouts/BaseLayout';
import LayoutBlank from '@/components/layouts/LayoutBlank';
import Main from '../pages/Management/Main';
import LayoutWithoutNavFooter from '@/components/layouts/LayoutWithoutNavFooter';

export default [
  {
    path: '/management',
    name: 'management',
    navbar: true,
    title: 'management',
    icon: 'ion ion-md-settings',
    component: BaseLayout,
    meta: { perm: 'Navbar.Management' },
    children: [
      {
        path: '/management',
        title: 'management',
        icon: 'ion ion-md-setting',
        name: 'management',
        component: Main,
        hide: true,
        meta: { perm: 'Navbar.Management' },
      },
      {
        path: '',
        title: 'device_management',
        icon: 'ion ion-md-car',
        name: 'vehicle_process',
        component: LayoutBlank,
        meta: { perm: 'Pages.VehicleProcess' },
        children: [
          {
            path: 'vehicle_process',
            title: 'vehicle_operations',
            icon: 'ion ion-md-car',
            name: 'vehicle_process',
            component: () => import('@/pages/Management/DeviceManagement/VehicleProcess/Vehicles'),
            meta: { perm: 'Pages.VehicleProcess' },
          },
          {
            path: 'save_vehicle',
            title: 'save_vehicle',
            hide: true,
            icon: 'ion ion-md-car',
            name: 'save_vehicle',
            props: true,
            component: () => import('@/pages/Management/DeviceManagement/VehicleProcess/SaveVehicle'),
            meta: { perm: 'Pages.VehicleProcess' },
          },
          {
            path: 'control_card',
            title: 'control_card_management',
            icon: 'ion ion-md-card',
            name: 'control_card',
            component: () => import('@/pages/Management/DeviceManagement/ControlCard/ControlCard'),
            meta: { perm: 'Pages.ControlCard' },
          },
          {
            path: 'device_list',
            title: 'device_simcard_list',
            icon: 'ion ion-md-list',
            name: 'device_simcard_list',
            component: () => import('@/pages/Management/DeviceManagement/DeviceList/Devices'),
            meta: { perm: 'Pages.DeviceSimCardProcess' },
          },
          {
            path: 'vehicle_signals',
            title: 'vehicle_signals',
            icon: 'ion ion-md-wifi',
            name: 'vehicle_signals',
            component: () => import('@/pages/Management/DeviceManagement/VehicleSignals/VehicleSignals'),
            meta: { perm: 'Pages.VehicleSignals' },
          },
          {
            path: 'vehicle_settings',
            title: 'vehicle_settings',
            icon: 'ion ion-ios-settings',
            name: 'vehicle_settings',
            hide: true,
            component: () => import('@/pages/Management/DeviceManagement/VehicleProcess/VehicleSettings'),
            meta: { perm: 'Pages.VehicleSettings' },
          },
          {
            path: 'device_informations',
            title: 'device_info',
            icon: 'ion ion-md-card',
            name: 'device_informations',
            component: () => import('@/pages/Management/DeviceManagement/DeviceInformations/DeviceInformations'),
            meta: { perm: 'Pages.DeviceInformations' },
          },
          {
            path: 'system_port_status',
            title: 'system_port_status',
            icon: 'fab fa-megaport',
            name: 'system_port_status',
            component: () => import('@/pages/Management/DeviceManagement/SystemPortManagement/SystemPort'),
            meta: { perm: 'Pages.SystemPorts' },
          },
          {
            path: 'raw_data',
            name: 'raw_data',
            title: 'vehicle_raw_data',
            icon: 'ion ion-md-car',
            meta: { perm: 'Pages.VehicleCameras' },
            component: () => import('@/pages/Management/DeviceManagement/VehicleRawData/RawDataList'),
          },
          {
            path: 'scheduled_commands',
            name: 'scheduled_commands',
            title: 'scheduled_commands',
            icon: 'fa fa-clock',
            meta: { perm: 'Pages.ScheduledCommandManagement' },
            component: () => import('@/pages/Management/DeviceManagement/ScheduledCommandManagement/ScheduledCommands'),
          },
        ],
      },
      {
        path: '',
        title: 'fleet_management',
        icon: 'ion ion-md-git-network',
        meta: { perm: 'Pages.FleetManagement' },
        component: LayoutBlank,
        children: [
          {
            path: 'fleet_proccess',
            title: 'fleet_operations',
            icon: 'ion ion-md-git-network',
            name: 'fleet_proccess',
            component: () => import('@/pages/Management/FleetManagement/FleetProcess/Fleets'),
            meta: { perm: 'Pages.FleetProcess' },
          },
          {
            path: 'fleet_vehicle_proccess',
            title: 'fleet_vehicle_operations',
            hide: true,
            icon: 'ion ion-md-git-network',
            name: 'fleet_vehicle_proccess',
            component: () => import('@/pages/Management/FleetManagement/FleetProcess/FleetVehicle'),
            meta: { perm: 'Pages.FleetProcess' },
          },
          {
            path: 'vehicle_group_list',
            title: 'vehicle_grouping',
            icon: 'ion ion-ios-git-network',
            name: 'vehicle_group_list',
            meta: { perm: 'Pages.VehicleGroupList' },
            component: () => import('@/pages/Management/FleetManagement/VehicleGroup/VehicleGroupList'),
          },
          {
            path: 'new_vehicle_group',
            title: 'new_vehicle_grouping',
            icon: 'ion ion-md-git-network',
            name: 'new_vehicle_group',
            meta: { perm: 'Pages.NewVehicleGroup' },
            hide: true,
            component: () => import('@/pages/Management/FleetManagement/VehicleGroup/NewVehicleGroup'),
          },
          {
            path: 'integrations',
            title: 'integrations',
            icon: 'ion ion-md-cloud-download',
            name: 'integrations',
            meta: { perm: 'Pages.Integrations' },
            component: () => import('@/pages/Management/FleetManagement/Integrations/IntegrationList'),
          },
        ],
      },
      {
        path: '',
        title: 'user_management',
        icon: 'ion ion-md-people',
        component: LayoutBlank,
        meta: { perm: 'Pages.UserProcess' },
        children: [
          {
            path: 'save_user',
            title: 'save_user',
            hide: true,
            icon: 'fas fa-user-plus',
            name: 'save_user',
            component: () => import('@/pages/Management/UserManagement/UserProcess/SaveUser'),
            meta: { perm: 'Pages.UserProcess' },
          },
          {
            path: 'edit_user',
            title: 'edit_user',
            icon: 'ion ion-md-people',
            name: 'edit_user',
            hide: true,
            component: () => import('@/pages/Management/UserManagement/UserProcess/SaveUser'),
            meta: { perm: 'Pages.UserProcess' },
          },
          {
            path: 'user_process',
            title: 'user_operations',
            icon: 'fas fa-user-edit',
            name: 'user_process',
            component: () => import('@/pages/Management/UserManagement/UserProcess/Users'),
            meta: { perm: 'Pages.UserProcess' },
          },
          {
            path: 'user_permissions',
            title: 'user_permission_processes',
            icon: 'fas fa-users',
            name: 'user_permissions',
            component: () => import('@/pages/Management/UserManagement/UserProcess/UserPermissions'),
            meta: { perm: 'Pages.UserPermissions' },
          },
          // {
          //   path: 'permission_management',
          //   title: 'permission_management',
          //   icon: 'fas fa-users',
          //   name: 'permission_management',
          //   component: () =>
          //                 import ('@/pages/Management/UserManagement/PermissionManagement/PermissionManagement'),
          //   meta: { perm: 'Pages.PermissionManagement'}
          // },
          {
            path: 'permissions',
            title: 'permission_management',
            icon: 'fas fa-users',
            name: 'permissions',
            component: () => import('@/pages/Management/UserManagement/PermissionManagement/PermissionManagement'),
            meta: { perm: 'Pages.PermissionManagement' },
          },
          {
            path: 'permissions/:id',
            title: 'edit_permission_management',
            icon: 'fa fa-edit',
            name: 'edit_permission_management',
            hide: true,
            meta: { perm: 'Pages.PermissionManagement' },
            component: () => import('@/pages/Management/UserManagement/PermissionManagement/EditPermissionManagement'),
          },
          // {
          //   path: 'edit_permission_management/:id',
          //   title: 'edit_permission_management',
          //   icon: 'fa fa-edit',
          //   name: 'edit_permission_management',
          //   hide: true,
          //   meta: { perm: 'Pages.PermissionManagement' },
          //   component: () =>
          //                     import ('@/pages/Management/UserManagement/PermissionManagement/EditPermissionManagement')
          // },
          {
            path: 'user_group_operations',
            title: 'user_group_operations',
            icon: 'fas fa-users-cog',
            name: 'user_group_operations',
            component: () => import('@/pages/Management/UserManagement/UserGroupOperations/UserGroupOperations'),
            meta: { perm: 'Pages.UserPermissions' },
          },
          {
            path: 'login_logout_list',
            title: 'login_logout_list',
            icon: 'ion ion-md-door',
            name: 'login_logout_list',
            component: () => import('@/pages/Management/UserManagement/LoginLogoutLog/LoginLogoutLog'),
            meta: { perm: 'Pages.HourPermissions' },
          },
          {
            path: 'hour_based_permissions',
            title: 'hour_based_permission_operations',
            icon: 'ion ion-md-clock',
            name: 'hour_based_permissions',
            component: () =>
              import('@/pages/Management/UserManagement/HourBasedPermissionProcesses/HourBasedPermissions'),
            meta: { perm: 'Pages.HourPermissions' },
          },
          {
            path: 'hour_based_permission_settings',
            title: 'hour_based_permission_settings',
            icon: 'ion ion-md-clock',
            name: 'hour_based_permission_settings',
            hide: true,
            component: () =>
              import('@/pages/Management/UserManagement/HourBasedPermissionProcesses/HourBasedPermissionSettings'),
            meta: { perm: 'Pages.HourPermissionSettings' },
          },
          {
            path: 'language_progress',
            title: 'language_operations',
            icon: 'ion ion-md-people',
            name: 'language_progress',
            component: () => import('@/pages/Management/UserManagement/Language/ListLanguage'),
            meta: { perm: 'Pages.LanguageOperations' },
          },
        ],
      },
      {
        path: '',
        title: 'vehicle_management',
        icon: 'ion ion-md-car',
        meta: { perm: 'Pages.VehicleLicenceList' },
        component: LayoutBlank,
        children: [
          {
            path: 'vehicle_license_list',
            title: 'license_transactions',
            icon: 'far fa-file',
            name: 'vehicle_license_list',
            meta: { perm: 'Pages.VehicleLicenceList' },
            component: () => import('@/pages/Management/VehicleManagement/License/LicenseList'),
          },
          {
            path: 'new_vehicle_license',
            title: 'new_vehicle_license',
            icon: 'fas fa-sticky-note',
            name: 'new_vehicle_license',
            meta: { perm: 'Pages.NewVehicleLicence' },
            hide: true,
            component: () => import('@/pages/Management/VehicleManagement/License/NewLicense'),
          },

          {
            path: 'edit_vehicle_license',
            title: 'edit_vehicle_license',
            icon: 'fas fa-edit',
            name: 'edit_vehicle_license',
            hide: true,
            meta: { perm: 'Pages.EditVehicleLicence' },
            component: () => import('@/pages/Management/VehicleManagement/License/EditLicense'),
          },
          {
            path: 'new_examination',
            title: 'new_vehicle_inspection',
            icon: 'fas fa-sticky-note',
            name: 'new_examination',
            hide: true,
            meta: { perm: 'Pages.NewExamination' },
            component: () => import('@/pages/Management/VehicleManagement/Examination/NewExamination'),
          },
          {
            path: 'examination_list',
            title: 'inspection_procedures',
            icon: 'ion ion-ios-list',
            name: 'examination_list',
            meta: { perm: 'Pages.ExaminationList' },
            component: () => import('@/pages/Management/VehicleManagement/Examination/ExaminationList'),
          },
          {
            path: 'edit_examination',
            title: 'edit_inspection',
            icon: 'fas fa-edit',
            name: 'edit_examination',
            meta: { perm: 'Pages.EditExamination' },
            hide: true,
            component: () => import('@/pages/Management/VehicleManagement/Examination/EditExamination'),
          },
          {
            path: 'new_vehicle_insurance',
            title: 'new_vehicle_insurance',
            icon: 'fas fa-sticky-note',
            name: 'vehicle_insurance',
            meta: { perm: 'Pages.NewVehicleInsurance' },
            hide: true,
            component: () => import('@/pages/Management/VehicleManagement/Insurance/NewInsurance'),
          },
          {
            path: 'vehicle_insurance_list',
            title: 'insurance_transactions',
            icon: 'far fa-file',
            name: 'vehicle_insurance_list',
            meta: { perm: 'Pages.VehicleInsuranceList' },
            component: () => import('@/pages/Management/VehicleManagement/Insurance/InsuranceList'),
          },
          {
            path: 'edit_vehicle_insurance',
            title: 'edit_vehicle_insurance',
            icon: 'fas fa-edit',
            name: 'edit_vehicle_insurance',
            meta: { perm: 'Pages.EditVehicleInsurance' },
            hide: true,
            component: () => import('@/pages/Management/VehicleManagement/Insurance/EditInsurance'),
          },
          {
            path: 'new_maintenance',
            title: 'new_maintenance',
            icon: 'fas fa-sticky-note',
            name: 'maintenance',
            hide: true,
            meta: { perm: 'Pages.NewMaintenance' },
            component: () => import('@/pages/Management/VehicleManagement/Maintenance/NewMaintenance'),
          },
          {
            path: 'maintenance_list',
            title: 'maintenance_operations',
            icon: 'ion ion-ios-construct',
            name: 'maintenance_list',
            meta: { perm: 'Pages.MaintenanceList' },
            component: () => import('@/pages/Management/VehicleManagement/Maintenance/MaintenanceList'),
          },
          {
            path: 'edit_maintenance',
            title: 'edit_maintenance',
            icon: 'fas fa-edit',
            name: 'edit_maintenance',
            hide: true,
            meta: { perm: 'Pages.EditMaintenance' },
            component: () => import('@/pages/Management/VehicleManagement/Maintenance/EditMaintenance'),
          },
          {
            path: 'new_traffic_penalty',
            title: 'new_traffic_penalty',
            icon: 'fas fa-sticky-note',
            name: 'traffic_penalty',
            hide: true,
            meta: { perm: 'Pages.NewTrafficPenalty' },
            component: () => import('@/pages/Management/VehicleManagement/TrafficPenalty/NewTrafficPenalty'),
          },
          {
            path: 'traffic_penalty_list',
            title: 'penalty_transactions',
            icon: 'fas fa-ban',
            name: 'traffic_penalty_list',
            meta: { perm: 'Pages.TrafficPenaltyList' },
            component: () => import('@/pages/Management/VehicleManagement/TrafficPenalty/TrafficPenaltyList'),
          },
          {
            path: 'edit_traffic_penalty',
            title: 'edit_traffic_penalty',
            icon: 'fas fa-edit',
            name: 'edit_traffic_penalty',
            hide: true,
            meta: { perm: 'Pages.MaintenanceList' },
            component: () => import('@/pages/Management/VehicleManagement/TrafficPenalty/EditTrafficPenalty'),
          },
          // yakıt işlemleri ve ortalama yakıt işlemleri buradan alındı
          {
            path: 'prefix',
            title: 'prefix_operations',
            icon: 'fa fa-tags',
            name: 'prefix',
            meta: { perm: 'Pages.Prefix' },
            component: () => import('@/pages/Management/VehicleManagement/Prefix/Prefixes'),
          },
          {
            path: 'suppliers',
            title: 'supplier_transactions',
            icon: 'fa fa-building',
            name: 'suppliers',
            meta: { perm: 'Pages.Suppliers' },
            component: () => import('@/pages/Management/VehicleManagement/Suppliers/SuppliersList'),
          },
          {
            path: 'new_supplier',
            title: 'new_supplier',
            icon: 'fa fa-building',
            name: 'new_supplier',
            hide: true,
            meta: { perm: 'Pages.NewSuppliers' },
            component: () => import('@/pages/Management/VehicleManagement/Suppliers/NewSupplier'),
          },
          {
            path: 'edit_supplier',
            title: 'edit_supplier',
            icon: 'fa fa-edit',
            name: 'edit_supplier',
            hide: true,
            meta: { perm: 'Pages.EditSuppliers' },
            component: () => import('@/pages/Management/VehicleManagement/Suppliers/EditSupplier'),
          },
          {
            path: 'shift_list',
            title: 'shift_transactions',
            icon: 'fas fa-clock',
            name: 'shift_list',
            meta: { perm: 'Pages.ShiftList' },
            component: () => import('@/pages/Management/VehicleManagement/Shift/ShiftList'),
          },
          {
            path: 'shift_management',
            title: 'shift_settings',
            icon: 'fa fa-clock',
            name: 'shift_management',
            hide: true,
            meta: { perm: 'Pages.ShiftManagement' },
            component: () => import('@/pages/Management/VehicleManagement/Shift/ShiftManagement'),
          },
          {
            path: 'assignment_list',
            title: 'vehicle_missions',
            icon: 'fas fa-align-left',
            name: 'assignment_list',
            meta: { perm: 'Pages.AssignmentList' },
            component: () => import('@/pages/Management/VehicleManagement/VehicleAssignment/AssignmentList'),
          },
          {
            path: 'new_assignment',
            title: 'vehicle_missions',
            icon: 'fas fa-align-left',
            name: 'new_assignment',
            hide: true,
            meta: { perm: 'Pages.NewAssignment' },
            component: () => import('@/pages/Management/VehicleManagement/VehicleAssignment/NewAssignment'),
          },
          {
            path: 'vehicle_contract_tracking',
            title: 'vehicle_contract_tracking',
            icon: 'fa fa-briefcase',
            name: 'vehicle_contract_tracking',
            meta: { perm: 'Pages.VehicleContractTracking' },
            component: () => import('@/pages/Management/VehicleManagement/VehicleContractTracking/ContractList'),
          },
          // {
          //    path: 'vehicle_authorizations',
          //    title: 'vehicle_authorizations',
          //    icon: 'fas fa-id-card-alt',
          //    name: 'vehicle_authorizations',
          //    meta: { perm: 'Pages.NewAssignment' },
          //    component: () =>
          //        import ('@/pages/Management/VehicleManagement/VehicleDriverAssignment/VehicleAuthorizations')
          // }
        ],
      },
      {
        path: '',
        title: 'montage_management',
        icon: 'fa fa-wrench',
        meta: { perm: 'Pages.MontageManagement' },
        component: LayoutBlank,
        children: [
          {
            path: 'montage_proccess',
            title: 'montage_operations',
            icon: 'fa fa-cog',
            name: 'montage_proccess',
            meta: { perm: 'Pages.MontageProcess' },
            component: () => import('@/pages/Management/MontageManagement/MontageDemontage'),
          },
          {
            path: 'address_proccess',
            title: 'address_operations',
            icon: 'fa fa-address-book',
            name: 'address_proccess',
            meta: { perm: 'Pages.MontageAddressProcess' },
            component: () => import('@/pages/Management/MontageManagement/Address'),
          },
          {
            path: 'plate_chassis_inquiry',
            title: 'plate_chassis_inquiry',
            icon: 'ion ion-md-cloud-download',
            name: 'plate_chassis_inquiry',
            meta: { perm: 'Pages.MontagePlateChassisInquiry' },
            component: () => import('@/pages/Management/MontageManagement/PlateChassisInquiry'),
          },
          {
            path: 'powercut_alarm',
            title: 'powercut_alarm',
            icon: 'fa fa-bolt',
            name: 'powercut_alarm',
            meta: { perm: 'Pages.MontagePowerCutAlarmProccess' },
            component: () => import('@/pages/Management/MontageManagement/PowerCutAlarm'),
          },
          {
            path: 'device_stock_operations',
            title: 'device_stock_operations',
            icon: 'fa fa-building',
            name: 'device_stock_operations',
            meta: { perm: 'Pages.MontageDeviceStockOperations' },
            component: () => import('@/pages/Management/MontageManagement/DeviceStockOperations'),
          },
          {
            path: 'service_fee_operations',
            title: 'service_fee_operations',
            icon: 'ion ion-md-cash',
            name: 'service_fee_operations',
            meta: { perm: 'Pages.ServiceFeeOperations' },
            component: () => import('@/pages/Management/MontageManagement/ServiceFeeOperations'),
          },
          {
            path: 'service_fee_settings',
            title: 'service_fee_settings',
            icon: 'ion ion-md-cash',
            name: 'service_fee_settings',
            meta: { perm: 'Pages.ServiceFeeSettings' },
            component: () => import('@/pages/Management/MontageManagement/ServiceFeeSettings'),
          },
        ],
      },
      {
        path: '',
        title: 'personnel_operations',
        icon: 'fas fa-users-cog',
        meta: { perm: 'Pages.PersonnelList' },
        component: LayoutBlank,
        children: [
          {
            path: 'personnel_list',
            title: 'personnel_list',
            icon: 'ion ion-md-people',
            name: 'personnel_list',
            meta: { perm: 'Pages.PersonnelList' },
            component: () => import('@/pages/Management/StaffManagement/Personnel/PersonnelList'),
          },
          {
            path: 'new_personnel',
            title: 'new_personnel',
            icon: 'ion ion-md-people',
            name: 'new_personnel',
            hide: true,
            meta: { perm: 'Pages.NewPersonel' },
            component: () => import('@/pages/Management/StaffManagement/Personnel/NewPersonnel'),
          },
          {
            path: 'qr_code',
            title: 'qr_code_operations',
            icon: 'ion ion-md-qr-scanner',
            name: 'qr_code',
            meta: { perm: 'Pages.QRCodeProcess' },
            component: () => import('@/pages/Management/StaffManagement/QRCodeOperations/QRCode'),
          },
          {
            path: 'title',
            title: 'title_transactions',
            icon: 'ion ion-md-people',
            name: 'title',
            meta: { perm: 'Pages.TitleManagement' },
            component: () => import('@/pages/Management/StaffManagement/Statu/PersonnelTitle'),
          },

          {
            path: 'unit',
            title: 'unit_transactions',
            icon: 'ion ion-md-people',
            name: 'unit',
            meta: { perm: 'Pages.Unit' },
            component: () => import('@/pages/Management/StaffManagement/Unit/Unit'),
          },
        ],
      },
      // {
      //   path: '',
      //   title: 'support',
      //   icon: 'fas fa-server',
      //   meta: { perm: 'Pages.PersonnelList' },
      //   component: LayoutBlank,
      //   children: [{
      //     path: 'support_list',
      //     title: 'support_list',
      //     icon: 'ion ion-md-people',
      //     name: 'support_list',
      //     meta: { perm: 'Pages.SupportList' },
      //     component: () => import ('@/pages/Management/Support/SupportList')
      //   }
      //   ]
      // }
      {
        path: '',
        title: 'fuel_management',
        icon: 'fas fa-gas-pump',
        meta: { perm: 'Pages.FuelManagement' },
        component: LayoutBlank,
        children: [
          {
            path: 'integrations_fuel',
            title: 'integrations',
            icon: 'ion ion-md-cloud-download',
            name: 'integrations_fuel',
            meta: { perm: 'Pages.Integrations' },
            component: () => import('@/pages/Management/FleetManagement/Integrations/IntegrationList'),
          },
          {
            path: 'new_fuel',
            title: 'new_fuel',
            icon: 'fas fa-sticky-note',
            name: 'fuel',
            hide: true,
            meta: { perm: 'Pages.NewFuel' },
            component: () => import('@/pages/Management/FuelManagement/Fuel/NewFuel'),
          },
          {
            path: 'fuel_list',
            title: 'fuel_operations',
            icon: 'fas fa-gas-pump',
            name: 'fuel_list',
            meta: { perm: 'Pages.FuelList' },
            component: () => import('@/pages/Management/FuelManagement/Fuel/FuelList'),
          },
          {
            path: 'edit_fuel',
            title: 'edit_fuel',
            icon: 'fas fa-edit',
            name: 'edit_fuel',
            hide: true,
            meta: { perm: 'Pages.FuelEdit' },
            component: () => import('@/pages/Management/FuelManagement/Fuel/EditFuel'),
          },
          {
            path: 'average_fuel_consumption_proccess',
            title: 'average_fuel_consumption_proccess',
            icon: 'ion ion-md-color-fill',
            name: 'average_fuel_consumption_proccess',
            meta: { perm: 'Pages.AverageFuelConsumption' },
            component: () =>
              import('@/pages/Management/FuelManagement/AverageFuelConsumption/AverageFuelConsumptionList'),
          },
        ],
      },
    ],
  },
  {
    path: '/management/cameras',
    navbar: false,
    title: 'vehicle_cameras',
    icon: 'ion ion-md-camera',
    component: LayoutWithoutNavFooter,
    children: [
      {
        path: '',
        title: 'vehicle_cameras',
        icon: 'ion ion-md-camera',
        name: 'cameras',
        meta: { perm: 'Pages.VehicleCameras' },
        component: () => import('@/pages/Management/DeviceManagement/CameraManagement/Cameras'),
      },
    ],
  },
];
